import React from 'react'
import { subscribe } from 'react-contextual'
import { CurrencyText } from 'views/components'
import Close from 'views/components/atoms/Svgs/Close'
import SuspenseAccountsProvider from '../../SuspenseAccountsProvider'
import { SuspenseAccountsContext } from '../../types'
import ViewAllocatedReference from './ViewAllocatedSuspenseAccount'
import ViewUnallocatedReference from './ViewUnallocatedAccount'
import styles from './ViewSuspenseAccount.module.scss'

type ViewSuspenseAccountProps = Pick<SuspenseAccountsContext, 'currentReference' | 'closeReference'>

const ViewSuspenseAccount = ({ currentReference, closeReference }: ViewSuspenseAccountProps): React.ReactElement => {
  return (
    <>
      <header className={styles.header}>
        <div className={styles.summary}>
          <span className={styles.eyebrow}>Reference used</span>
          <h2>{currentReference?.referenceUsed}</h2>
          <p className={styles.meta}>
            <span>Transaction ID: {currentReference?.txId?.substring(0, 9)}</span>
            <strong>
              <CurrencyText>{currentReference?.amount ?? 0}</CurrencyText>
            </strong>
          </p>
        </div>
        <button className={styles.close} onClick={closeReference} aria-label="Close">
          <Close />
        </button>
      </header>
      <div className={styles.card}>
        {currentReference?.allocatedAt ? (
          <ViewAllocatedReference currentReference={currentReference} />
        ) : (
          <ViewUnallocatedReference currentReference={currentReference} closeReference={closeReference} />
        )}
      </div>
    </>
  )
}

export default subscribe(
  [SuspenseAccountsProvider],
  ({ currentReference, closeReference }: SuspenseAccountsContext) => ({
    currentReference,
    closeReference,
  }),
)(ViewSuspenseAccount)
